<app-card-table
    #doctorsCertificatesTable
    [tableTitle]="title()"
    [gridData]="store.data.getUserSecrets()"
    [refreshCallback]="store.api.getUserSecrets"
    [columns]="columns"
    [additionalFilter]="additionalFilters()"
    [translatePrefix]="'common.'"
    [hideCheckboxes]="true"
    (deleteCallbackWithEvent)="deleteSecret($event)"
    (createCallback)="addSecret()"
>
    <ng-template pTemplate="type" let-data="data">
        {{ 'service.settings.eprescriptions.secretType.' + data | translate }}
    </ng-template>
</app-card-table>
